import { memo, useEffect, useState } from 'react';
import { Box, IconButton } from '@material-ui/core';
import clsx from 'clsx';
import { useSQuadrantStyles } from './style';
import { BarIcon } from '../sicons';
import SText from '../sui/stext';
import { SRoundedContainer } from '../sui/srounded-container';

interface TopContent {
  title?: string;
  content?: JSX.Element;
}

interface SQuadrantLayoutProps {
  defaultCollapsed?: boolean;
  showCollapseButton?: boolean;
  invertedRow?: boolean;
  topLeft?: TopContent;
  topRight?: TopContent;
  bottomLeft: JSX.Element;
  bottomRight: JSX.Element;
  header?: JSX.Element;
}

const SQuadrantLayout = ({
  defaultCollapsed = false,
  showCollapseButton = true,
  invertedRow = false,
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  header
}: SQuadrantLayoutProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  const classes = useSQuadrantStyles();

  useEffect(() => {
    setIsCollapsed(defaultCollapsed);
  }, [defaultCollapsed]);

  return (
    <Box className={classes.container}>
      {header}
      <Box className={classes.grid}>
        {!isCollapsed && (
          <Box
            style={{ maxWidth: 320, minWidth: 320 }}
            className={clsx({
              [classes.left]: !invertedRow,
              [classes.right]: invertedRow,
              [classes.order2]: invertedRow,
              [classes.gridItem]: true
            })}>
            {topLeft && (
              <Box className={classes.topConatiner}>
                {topLeft?.title && (
                  <SText weight="bold" title={topLeft.title} />
                )}
                {topLeft?.content || null}
              </Box>
            )}
            {!!bottomLeft && (
              <SRoundedContainer className={classes.bottomContainer}>
                {bottomLeft}
              </SRoundedContainer>
            )}
          </Box>
        )}
        <Box className={classes.gridItem}>
          {topRight && (
            <Box className={classes.topConatiner}>
              {showCollapseButton && (
                <IconButton
                  onClick={() => setIsCollapsed(collapsed => !collapsed)}>
                  <BarIcon />
                </IconButton>
              )}
              {topRight?.title && (
                <SText weight="bold" title={topRight.title} />
              )}
              {topRight?.content || null}
            </Box>
          )}
          <SRoundedContainer className={classes.bottomContainer}>
            {bottomRight}
          </SRoundedContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(SQuadrantLayout);
